module.exports = __webpack_public_path__ + "img/companyIntro36.cb9a04f6.png";